import React from 'react';
import PropTypes from 'prop-types';

export default function ResultKicker({ item }) {
  const contentTypeNames = {
    news: 'News',
    audio: 'Podcast',
    slide: 'Presentation',
    video: 'Video',
    case_study: 'Case',
    basic_html: 'Partner Content',
    conference: 'Conference',
    manuscript: 'Manuscript',
  };

  const contentTypeLink = item.type ? (
    <span className="field field--name-field-content-type">
      <a href={`/search?type=${item.type}&searched=true`}>
        {contentTypeNames[item.type]}
      </a>
    </span>
  ) : null;

  // Subtype.
  // Hide subtype for slides.
  const hasSubtype = item.subtype && item.type !== 'slide';
  const subtypeLink = hasSubtype ? (
    <span className="field field--name-field-subtype">
      <a
        href={`/search?type=${item.type}&subtype=${item.subtype}&searched=true`}
      >
        {item.subtype}
      </a>
    </span>
  ) : null;

  // Subtype - Level 2.
  const subtypeLevelTwoLink = item.subtype_sub_level ? (
    <span className="field field--name-field-subtype-level-two">
      <a
        href={`/search?type=${item.type}&subtype_sub_level=${item.subtype_sub_level}&searched=true`}
      >
        {item.subtype_sub_level}
      </a>
    </span>
  ) : null;

  // Conference tag.
  const conferenceTag = item.conference_tag && item.conference_url ? (
    <span className="field field--name-field-conference-tag">
      <a
        href={item.conference_url}
      >
        {item.conference_tag}
      </a>
    </span>
  ) : null;

  // Gold - Platinum.
  const isGoldPlatinum = item.type === 'video'
    && !item.free_content
    && item.subtype === 'Live Case';
  const goldPlatinum = isGoldPlatinum ? (
    <span className="subscription-label">
      <span>Gold</span>
      &nbsp;
      <span>Platinum</span>
    </span>
  ) : null;

  // Sponsored.
  const isSponsored = item.type === 'video'
    && item.tags
    && item.tags.indexOf('sponsored') >= 0;
  const sponsored = isSponsored ? (
    <span className="sponsored-label">Sponsored</span>
  ) : null;

  const pretitleClasses = [
    'pre-title',
    hasSubtype ? 'pre-title--has-subtype' : null,
    item.conference_tag ? 'pre-title--has-conference-tag' : null,
    isGoldPlatinum ? 'pre-title--video-platinum-gold' : null,
    isSponsored ? 'pre-title--video-sponsored' : null,
  ]
    .join(' ')
    .trim();

  return (
    <div className={pretitleClasses}>
      {contentTypeLink}
      {subtypeLink}
      {subtypeLevelTwoLink}
      {conferenceTag}
      {goldPlatinum}
      {sponsored}
    </div>
  );
}

ResultKicker.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string,
    subtype: PropTypes.string,
    subtype_sub_level: PropTypes.string,
    conference_tag: PropTypes.string,
    conference_url: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    free_content: PropTypes.bool,
  }).isRequired,
};
